/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Ws_S4Inputs */

const en_mk_tut_ws_s4 = /** @type {(inputs: Mk_Tut_Ws_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You enter a five-step guide. Fill it in roughly or press **Skip** — everything can be changed later in Settings.`)
};

const id_mk_tut_ws_s4 = /** @type {(inputs: Mk_Tut_Ws_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda masuk ke pemandu lima langkah. Isi seadanya atau tekan **Lewati** — semuanya bisa diubah kapan saja lewat Pengaturan.`)
};

/**
* | output |
* | --- |
* | "You enter a five-step guide. Fill it in roughly or press **Skip** — everything can be changed later in Settings." |
*
* @param {Mk_Tut_Ws_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_ws_s4 = /** @type {((inputs?: Mk_Tut_Ws_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Ws_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_ws_s4(inputs)
	return en_mk_tut_ws_s4(inputs)
});